import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { TabProps } from './types';
import { useGithubRepos } from '../shared';

interface AdvancedTabProps extends TabProps {
  owner: string;
}

export function AdvancedTab({ config, onChange, owner }: AdvancedTabProps) {
  const { repos: templateRepos, loading: reposLoading } = useGithubRepos(
    owner,
    { topic: 'template-repository' },
  );

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 20 }}>
      {/* Branching Model */}
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="branching-model-label">Branching Model</InputLabel>
        <Select
          labelId="branching-model-label"
          value={config.branching_model}
          onChange={e =>
            onChange({
              ...config,
              branching_model: e.target.value as
                | 'trunk_based'
                | 'environment_based',
            })
          }
          label="Branching Model"
        >
          <MenuItem value="trunk_based">Trunk Based</MenuItem>
          <MenuItem value="environment_based">Environment Based</MenuItem>
        </Select>
      </FormControl>

      {/* Deployment Trigger — only for trunk_based */}
      {config.branching_model === 'trunk_based' && (
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="deployment-trigger-label">
            Deployment Trigger
          </InputLabel>
          <Select
            labelId="deployment-trigger-label"
            value={config.deployment_trigger}
            onChange={e =>
              onChange({
                ...config,
                deployment_trigger: e.target.value as 'push' | 'tag',
              })
            }
            label="Deployment Trigger"
          >
            <MenuItem value="push">Push</MenuItem>
            <MenuItem value="tag">Tag</MenuItem>
          </Select>
        </FormControl>
      )}

      {/* Template Repository */}
      <Autocomplete
        options={templateRepos.map(r => r.name)}
        loading={reposLoading}
        value={config.template_repo || null}
        onChange={(_, value) =>
          onChange({ ...config, template_repo: value ?? '' })
        }
        renderInput={params => (
          <TextField
            {...params}
            label="Template Repository"
            variant="outlined"
            fullWidth
          />
        )}
      />

      {/* Checkboxes */}
      <FormControlLabel
        control={
          <Checkbox
            checked={config.share_state}
            onChange={(_, checked) =>
              onChange({ ...config, share_state: checked })
            }
            color="primary"
          />
        }
        label="Share Terraform State"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={config.include_all_branches}
            onChange={(_, checked) =>
              onChange({ ...config, include_all_branches: checked })
            }
            color="primary"
          />
        }
        label="Include All Branches"
      />
    </Box>
  );
}
